import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=2726a049&"
import script from "./EditArticle.vue?vue&type=script&lang=js&"
export * from "./EditArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports